import Api from './api'

import Env from '../modules/env'
import Firebase from '../modules/firebase'

import localCookies from '../../public/localCookies.json'

export default {

    getUser: function () {

        return Api.get('/v3/users')

    },

    getSettings: function () {

        return Api.get('/v3/users/settings')

    },

    getStats: function () {

        return Api.get('/v3/users/stats')
    },

    updateUser: function ({firstname, lastname, birthYear, device}) {

        return Api.post('/v3/users/information', {firstname, lastname, birthYear, device})

    },

    updatePanel: function (email, bool) {

        return Api.put(`/v3/accounts/${email}/settings`, {name: 'inFoxPanel', value: bool})

    },

    updateActive: function (email, bool) {

        return Api.put(`/v3/accounts/${email}/settings`, {name: 'isActive', value: bool})

    },

    updateFetchNotifEmail: function (bool) {

        return Api.put('/v3/users/settings', {name: 'fetchNotifyByEmail', value: bool})

    },

    updateFetchLanguage: function (lang) {

        return Api.put('/v3/users/settings', {name: 'language', value: lang.split('-')[0]})

    },

    isRegisteredToPushNotifications: function (appInstanceId) {

        return Api.get(`/v3/users/settings?appInstanceId=${appInstanceId}`)

    },

    getGDPR: function () {

        return Api.put('/users/gdpr')
            .then(result => {
                return new Promise((resolve, reject) => {
                    return getGDPRLoop(result.requestId, resolve, reject)
                })
            })

    },

    async getCookiesList(Vue) {
        // $http.get create CORS error if get file from web
        // He need to get a local fake file
        let cookies = {}
        if (Env.isLocal()) {
            cookies = localCookies
        } else {
            await Vue.$http.get('/cookies.json')
                .then(response => {
                    cookies = response.body
                })
                .catch(() => {
                    cookies = localCookies
                })
        }

        // remove rules for EU user consent policy
        const isNotEuropeanCountry = !(await Firebase.getValue('isEea', 'Boolean'))
        if(isNotEuropeanCountry) {
            cookies = cookies.filter(cookie => cookie.name !== 'ad_user_data' && cookie.name !== 'ad_personalization')
        }

        return cookies
    }

}

function getGDPRLoop(requestId, resolve, reject) {
    return Api.get(`/users/gdpr/${requestId}`)
        .then(result => {
            if (result.done) {
                resolve(result.url)
            } else {
                setTimeout(() => {
                    return getGDPRLoop(requestId, resolve, reject)
                }, result.retry || 500)
            }

        })
        .catch(() => {
            this.$refs.toast.open()
            reject()
        })
}
